import React, { useMemo } from 'react';
import TopGroupStyled from './TopGroupStyled';
import { Box } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import dayjs from 'dayjs';
import PieOneML from '../echarts/PieOneML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { fmtThousand } from '@/utils/comUtil';

const TopGroup = ({ groupInfo }) => {
  //给饼状图传递的数据
  const pieData = useMemo(() => {
    if (JSON.stringify(groupInfo) !== '{}') {
      const sum = groupInfo.quantity * groupInfo.percent;
      return [
        { value: sum, name: '会员占比', percent: groupInfo.percent },
        { value: groupInfo.quantity, name: '总数' },
      ];
    }
    return [];
  }, [groupInfo]);
  const title = '全部会员：会员管理中全量会员';
  return (
    <TopGroupStyled>
      <Box>
        <Box className="card-content">
          <div className="top">
            <div className="top_bold">{groupInfo.title}</div>
            <div className="top_date">
              计算于：
              <span>{dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')}</span>
            </div>
          </div>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Box sx={{ height: '64px', width: '64px', marginLeft: '24px' }}>
            <PieOneML height="100%" data={pieData} />
          </Box>
          <Box
            style={{
              marginLeft: '60px',
              color: '#959595',
              // height: '64px',
              padding: '3px 0px 1px 0px',
            }}
          >
            <p style={{ fontSize: '12px' }}>
              <span
                style={{
                  fontWeight: '600',
                  fontSize: '24px',
                  color: '#424242',
                  display: 'inlin-block',
                  marginRight: '9px',
                }}
              >
                {fmtThousand(groupInfo.quantity, 0)}
              </span>
              人
            </p>
            <p style={{ fontSize: '12px', display: 'flex' }}>
              在&nbsp;全部会员&nbsp;中占比
              {JSON.stringify(groupInfo) !== '{}'
                ? (groupInfo.percent * 100).toFixed(2) + '%'
                : null}
              <Tooltip title={title} placement="top">
                <Box>
                  <SvgIconML
                    name="question"
                    size={12}
                    style={{ marginBottom: '-2px' }}
                  ></SvgIconML>
                </Box>
              </Tooltip>
            </p>
          </Box>
        </Box>
      </Box>
    </TopGroupStyled>
  );
};

export default TopGroup;
